import React from "react";
import { useField } from "formik";
import { TextField } from "@material-ui/core";

const MyTextField = ({
  label,
  fullWidth,
  placeholder,
  required,
  type,
  name,
  multiline,
  rows,
  disabled,
  style,
  autoComplete,
  formHelperText,
  /** When true, show `formHelperText` with error styling (e.g. client-side sanitization hints). */
  formHelperShowsError,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  InputLabelProps,
  ...props
}) => {
  const [field, meta] = useField(name);
  const errorText = meta.error && meta.touched ? meta.error : "";
  const helperText = errorText || formHelperText || "";
  const outlineError =
    !!errorText || (!!formHelperShowsError && !!formHelperText);
  return (
    <TextField
      {...field}
      {...props}
      variant="outlined"
      fullWidth={fullWidth}
      required={required}
      label={label}
      rows={rows}
      multiline={multiline}
      placeholder={placeholder}
      helperText={helperText}
      error={outlineError}
      type={type}
      id={`${name}`}
      style={style}
      disabled={disabled}
      autoComplete={autoComplete}
      InputLabelProps={{
        htmlFor: `${name}`,
        ...InputLabelProps,
      }}
      onChange={(e) => {
        if (onChangeProp) {
          onChangeProp(e);
        } else {
          field.onChange(e);
        }
      }}
      onBlur={(e) => {
        field.onBlur(e);
        onBlurProp?.(e);
      }}
    />
  );
};

export default MyTextField;
